<script>
    export let options;
    export let available_options;
    export let selected;
    export let id;

    import { onMount, afterUpdate } from 'svelte';
    import { select } from 'd3';

    onMount(() => {
        setDropdownWidth();
    });

    afterUpdate(() => {
        setDropdownWidth();
    });

    const setDropdownWidth = () => {
        const text = select(`#${id} .selected`).node().innerText;
        const width = select(`#${id}__hidden-span`)
            .text(text)
            .node()
            .getBoundingClientRect()
            .width;

        select(`#${id}`).style('width', `${width + 4}px`);
    };
</script>

<span id={`${id}__hidden-span`} class="dropdown-hidden-span"></span>
<select {id} bind:value={selected}>
    {#each options as option}
        <option 
            value={option.value} 
            disabled={!available_options.includes(option.value)}
            selected={option.value === selected}
            class={`${option.value === selected ? 'selected' : ''}`}
        >{option.title}</option>
    {/each}
</select>

<style>
    select, .dropdown-hidden-span {
        font-size: 16px;
        font-weight: 700;
    }
    select {
        display: inline-block;
        color: #1AAAD0;
        border: none;

        appearance: none;
        box-sizing: content-box;
        background-image: linear-gradient(45deg,transparent 50%,#1AAAD0 0),linear-gradient(135deg,#1AAAD0 50%,transparent 0);
        background-position: calc(100% - 13px) .4em,calc(100% - 8px) .4em,calc(100% - 2.5em) .5em;
        background-size: 5px 5px,5px 5px,1px 1.5em;
        background-repeat: no-repeat;
        padding-right: 24px;
    }
    select:focus {
        outline:none;
    }
    .dropdown-hidden-span {
        position: absolute;
        z-index: -1;
        color: transparent;
    }
</style>